export const groupsTableHeader = [
  {
    name: "Group Name",
    field: "name",
    align: "left",
    sorting: false,
  },
  {
    name: "Contacts",
    field: "contacts",
    align: "left",
    sorting: false,
  },
  {
    name: "Created On",
    field: "createdOn",
    align: "left",
    sorting: false,
  },
  {
    name: "Updated On",
    field: "updatedOn",
    align: "left",
    sorting: false,
  },
  {
    name: "Type",
    field: "type",
    align: "left",
    sorting: false,
  },
  {
    name: "Action",
    field: "action",
    align: "left",
    hide: true,
  },
];

export const contactGroupTableHeader = [
  {
    name: "Email",
    field: "emailId",
    align: "left",
    sorting: false,
  },
  {
    name: "Name",
    field: "name",
    align: "left",
    sorting: false,
  },
  {
    name: "Status",
    field: "status",
    align: "left",
    sorting: false,
  },
  {
    name: "Created On",
    field: "createdOn",
    align: "left",
    sorting: false,
  },
  {
    name: "Action",
    field: "remove",
    align: "center",
    sorting: false,
    hide: true
  },
];

export const groupsOptions = [
  {
    label: "All Groups",
    value: "all",
  },
  {
    label: "Team's Groups",
    value: "team",
  },
  {
    label: "My Groups",
    value: "my",
  },
];

export const userGroupsOptions = [
  {
    label: "All Groups",
    value: "all",
  },
  {
    label: "My Groups",
    value: "my",
  },
];

export const initialGroupFilterState = (
  page: number,
  rowsPerPage: number,
  searchText: string,
  dropdownValue: string
) => {
  return {
    page,
    rowsPerPage,
    searchText,
    dropdownValue: dropdownValue,
  };
};
